class Event {
    constructor(timestamp, message, name, serial, domainName, domainId) {
        this.timestamp = timestamp;
        this.message = message;
        this.cartName = name;
        this.cartSerial = serial;
        this.domainName = domainName;
        this.domainId = domainId;
    }
}

export default class CartsReportViewController {
    /* @ngInject */
    constructor($log, $location, $scope, ThingsService, EventsService, MomentService) {
        this.$log = $log;
        this.$location = $location;
        this.$scope = $scope;
        this.ThingsService = ThingsService;
        this.EventsService = EventsService;
        this.MomentService = MomentService;

        this.rootDomain = undefined;
        this.fromDate = this.MomentService.startOfWeek();
        this.toDate = this.MomentService.endOfDay();
        this.events = [];
        this.allEvents = [];
        this.isLoading = true;
    }

    $onInit() {
        this.getDomains();
        this.getAlarms()
            .then(() => {
                this.filterOnDomain(this.ThingsService.selectedDomain);
            });
        this.dateWatcher = this.$scope.$watchGroup(['$ctrl.fromDate', '$ctrl.toDate'],
            (newValue, oldValue) => {
                if ((newValue[0] !== oldValue[0]) ||
                    (newValue[1] !== oldValue[1])) {
                    this.getAlarms()
                        .then(() => {
                            this.filterOnDomain();
                        });
                }
            });
    }

    $onDestroy() {
        if (this.dateWatcher !== undefined) this.dateWatcher();
    }

    getDomains() {
        this.ThingsService.getDomains()
            .then((rootDomain) => {
                this.rootDomain = rootDomain;
            })
            .catch((error) => {
                this.$log.info(`Error getting domains: ${error}`);
            });
    }

    doFilterOnDomain(domainId) {
        this.ThingsService.selectedDomain = domainId;
        this.filterOnDomain(this.ThingsService.selectedDomain);
    }

    filterOnDomain(domainId) {
        // The original list of events contains events for all domains so
        // we only need to filter that list, no subsequent request is needed.
        if (domainId === undefined) {
            this.events = this.allEvents;
        } else {
            const ids = this.rootDomain.find(domainId).getAllIds();
            this.events = this.allEvents.filter(event => ids.includes(event.domainId));
        }
    }

    getAlarms() {
        const fieldOrEmpty = (thing, field) => {
            if (thing._source.state === undefined) return '';
            return thing._source.state[field];
        };
        /* eslint-disable no-underscore-dangle */
        const params = {
            domainId: this.ThingsService.selectedDomain,
            fromDate: this.fromDate,
            toDate: this.toDate,
        };
        let events = [];
        let cachedNames = {};

        // Start a sequential operation in order to produce a list
        // of all alarms for the current domain.
        this.isLoading = true;
        return this.EventsService.getEventsForDomain(params)
            .then((result) => {
                events = result.hits.hits;
                return this.ThingsService.getDomains();
            })
            .then((domains) => {
                // Go through all events and resolve domain name by id and
                // store that in a lookup object for later use.
                cachedNames = events
                    .filter(event => event._source.source.domain)
                    .reduce((map, event) => {
                        if (!(event._source.source.domain in map)) {
                            map[event._source.source.domain] = domains.resolveName(event._source.source.domain);
                        }
                        return map;
                    }, {});

                return this.ThingsService.getThings();
            })
            .then((things) => {
                // Convert the list of things to a object where details
                // can be looked up based on thingName / thingID.
                const thingData = things.hits.hits.reduce((map, thing) => {
                    map[thing._id] = {
                        id: thing._id,
                        name: thing._source.label,
                        serial: fieldOrEmpty(thing, 'serial'),
                    };
                    return map;
                }, {});

                // Construct the Alarm objects based on the event data and the resolved
                // information regarding thing and domain
                this.allEvents = events.map(event => new Event(
                    event._source.timestamp,
                    event._source.message,
                    thingData[event._source.source.thingName].name,
                    thingData[event._source.source.thingName].serial,
                    cachedNames[event._source.source.domain],
                    event._source.source.domain,
                    ));
            })
            .catch((error) => {
                this.$log.info(`Error getting events: ${error}`);
                this.$location.path('/login');
            })
            .finally(() => {
                this.isLoading = false;
            });
        /* eslint-enable no-underscore-dangle */
    }

    isEmpty() {
        return this.events && this.events.length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/carts-report-view/carts-report-view.controller.js